var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    width: 18.31,
    height: 18.31,
    viewBox: "0 0 18.31 18.31",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M16.165,1.431h-.858V0H13.876V1.431H4.435V0H3V1.431H2.146A2.148,2.148,0,0,0,0,3.576V16.165A2.148,2.148,0,0,0,2.146,18.31H16.165a2.148,2.148,0,0,0,2.146-2.146V3.576A2.148,2.148,0,0,0,16.165,1.431Zm.715,14.734a.716.716,0,0,1-.715.715H2.146a.716.716,0,0,1-.715-.715V6.723H16.88Zm0-10.872H1.431V3.576a.716.716,0,0,1,.715-.715H3V4.292H4.435V2.861h9.441V4.292h1.431V2.861h.858a.716.716,0,0,1,.715.715Z",
    fill: "#586682"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(2 8.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 2,
    fill: "#586682"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(6 8.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    fill: "#586682"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(9 8.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    fill: "#586682"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(12 8.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 1,
    fill: "#586682"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(14 8.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 1,
    fill: "#586682"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(2 11.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 2,
    height: 1,
    fill: "#586682"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(6 11.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    height: 1,
    fill: "#586682"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(9 11.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    height: 1,
    fill: "#586682"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(12 11.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 1,
    height: 1,
    fill: "#586682"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(2 13.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 2,
    height: 1,
    fill: "#586682"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(6 13.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    height: 1,
    fill: "#586682"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(9 13.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    height: 1,
    fill: "#586682"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(12 13.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 1,
    height: 1,
    fill: "#586682"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(14 11.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 1,
    height: 1,
    fill: "#586682"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };